/**
 * PC：视频全屏时字幕字号等比放大（阶梯式档位：大屏大字、小屏小字）
 * 抽离自 MusicPlayer.js
 */
import { useEffect } from 'react';

function getViewportScale(vw) {
  if (vw >= 2560) return 2.0;
  if (vw >= 1920) return 1.75;
  if (vw >= 1600) return 1.55;
  if (vw >= 1440) return 1.45;
  if (vw >= 1280) return 1.30;
  if (vw >= 1024) return 1.15;
  return 1.0;
}

export function useVideoSubtitleScale({
  isVideoFullscreen,
  isMobileViewport,
  currentMusicId,
  videoRef,
  lyricSettingsRef,
  miniLyricTextRef,
  miniLyricTransTextRef,
  videoSubtitleScaleRef,
  videoFullscreenViewportKeyRef,
  isVideoFullscreenRef,
  isMobileViewportRef
}) {
  useEffect(() => {
    try {
      if (isMobileViewport) {
        videoSubtitleScaleRef.current = 1;
        videoFullscreenViewportKeyRef.current = '';
        return;
      }
      if (!isVideoFullscreen) {
        videoSubtitleScaleRef.current = 1;
        videoFullscreenViewportKeyRef.current = '';
        return;
      }
      const video = videoRef.current;
      if (!video) return;

      const refreshCurrentSubtitleFontSize = () => {
        try {
          if (!miniLyricTextRef.current) return;
          const baseFsRaw = Number(lyricSettingsRef.current?.fontSize ?? 16);
          const baseFs = Number.isFinite(baseFsRaw) ? baseFsRaw : 16;
          const scale = (!isMobileViewportRef.current && isVideoFullscreenRef.current) ? (videoSubtitleScaleRef.current || 1) : 1;
          miniLyricTextRef.current.style.fontSize = `${Math.round(baseFs * scale)}px`;
          if (miniLyricTransTextRef.current && miniLyricTransTextRef.current.style.display !== 'none') {
            const transFs = Math.max(10, Math.round(baseFs * 0.75 * scale));
            miniLyricTransTextRef.current.style.fontSize = `${transFs}px`;
          }
        } catch (_) {}
      };

      const compute = (force = false) => {
        try {
          const vw = window.innerWidth || 0;
          const vh = window.innerHeight || 0;
          const key = `${vw}x${vh}`;
          if (!force && key && key === videoFullscreenViewportKeyRef.current) {
            refreshCurrentSubtitleFontSize();
            return;
          }
          videoFullscreenViewportKeyRef.current = key;
          videoSubtitleScaleRef.current = getViewportScale(vw);
          refreshCurrentSubtitleFontSize();
        } catch (_) {}
      };

      compute(true);
      requestAnimationFrame(() => compute(false));

      const onResize = () => compute(false);
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    } catch (_) {
      videoSubtitleScaleRef.current = 1;
      videoFullscreenViewportKeyRef.current = '';
    }
  }, [isVideoFullscreen, isMobileViewport, currentMusicId, videoRef, lyricSettingsRef, miniLyricTextRef, miniLyricTransTextRef, videoSubtitleScaleRef, videoFullscreenViewportKeyRef, isVideoFullscreenRef, isMobileViewportRef]);
}
